import React from 'react'
import s from './RouteMainInformations.less'
import RouteLabelComponents from './RouteLabelComponents'
import classnames from 'classnames'

const RouteMainInformationsTitle = ({ title, isSelected }) => (
  <div className={classnames(s.title, s.main)}>
    <RouteLabelComponents components={title} />
  </div>
)

export default RouteMainInformationsTitle
